// src/services/publicSurvey.ts
import { api } from "@/lib/apiClient";
import type {
  PublicSurveyOpen,
  PublicSurveySubmitIn,
  PublicSurveySubmitOut,
} from "@/types/publicSurvey";

export async function openPublicSurvey(token: string) {
  return api.get<PublicSurveyOpen>(`/public/surveys/${token}`, {
    auth: false,
  });
}

export async function submitPublicSurvey(
  token: string,
  payload: PublicSurveySubmitIn,
) {
  return api.post<PublicSurveySubmitOut>(
    `/public/surveys/${token}/responses`,
    payload,
    {
      auth: false,
    },
  );
}
